<template>
  <section id="profile">
    <page-title v-bind:title="'Profile'"></page-title>
    <div v-if="user" class="proile-content">
      <div class="member-general-info">
        <div class="member-circle">
          <span>{{user.name[0].toUpperCase()}}</span>
        </div>
        <span class="user">{{ user.email }}</span>
      </div>
      <div>
        <div class="property">
          <div class="bold">Name</div>
          
          <p v-if="!editName">{{user.name}}</p>
          <secondary-button v-if="!editName" class="compressed" :title="'Change name'" :act="() => {editName = true}"></secondary-button>

          <input v-if="editName" class="field" type="text" v-model="user.name"/>
          <primary-button v-if="editName" class="compressed" :title="'Save name'" :act="saveNewUserData"></primary-button>

        </div>
        
        <div class="property">

          <div class="bold">Surname</div>
          <p v-if="!user.surname"><i>{{'None set'}}</i></p>
          <p v-if="user.surname && !editSurname">{{user.surname}}</p>
          <secondary-button v-if="!editSurname" class="compressed" :title="'Change surname'" :act="() => {editSurname = true}"></secondary-button>

          <input v-if="editSurname" class="field" type="text" v-model="user.surname"/>
          <primary-button v-if="editSurname" class="compressed" :title="'Save surname'" :act="saveNewUserData"></primary-button>

        </div>
      </div>
      <secondary-button class="compressed logout" :title="'Log out'" :act="logout"></secondary-button>
    </div>
  </section>
</template>

<script>
import api from "@/api";
import db from "../firestore";

import pageTitle from "../components/PageTitle";
import SecondaryButton from "../components/shared/SecondaryButton";
import PrimaryButton from "../components/shared/PrimaryButton";

import updateUserInfo from "../gql/users/updateUserInfo.gql";

export default {
  components: {
    pageTitle,
    SecondaryButton,
    PrimaryButton
  },
  data() {
    return {
      editName: false,
      editSurname: false
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    logout: function() {
      api.logout();
    },
    goToEditMode: function() {
      this.editMode = true;
    },
    saveNewUserData: function() {
      const user_id = this.user.id;
      const name = this.user.name;
      const surname = this.user.surname;

      this.$apollo
        .mutate({
          mutation: updateUserInfo,
          variables: {
            user_id,
            name,
            surname
          }
        })
        .then(() => {
          this.editName = false;
          this.editSurname = false;
        })
        .catch(function(error) {
          this.$rollbar.error(error);
          alert("Could not update your personal details. Please try again later.");
        });
    },
    saveNewUserDataOld: function() {
      db;
    }
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';
hr {
  margin-top: 10px;
  margin-bottom: 10px;
}

.member-general-info {
  margin-top: 40px;
}

.field {
  width: 100%;
}

input {
  margin-top: 8px;
  margin-bottom: 8px;
  border: 1px solid theme.$light-grey-background;
  border-radius: 4px;
  width: 100%;
  padding: 6px 8px;
  box-sizing: border-box;
}

.member-circle {
  display: inline-block;
  background: theme.$secondary-color;
  color: theme.$text-color;
  font-size: 12px;
  height: 24px;
  width: 24px;
  line-height: 24px;
  text-align: center;
  vertical-align: 10px;
  border-radius: 50%;
  vertical-align: baseline;
  margin-right: 8px;
}

.btn-logout {
  cursor: pointer;
  margin-top: 25px;
  width: 100%;
  height: 30px;
  background: theme.$light-grey-background;
  border-radius: 4px;
  text-align: center;
}

.btn-logout span {
  font-size: 14px;
  vertical-align: -webkit-baseline-middle;
}

.btn-save {
  margin-top: 10px;
  width: 100%;
  height: 30px;
  background: theme.$primary-color;
  border-radius: 4px;
  text-align: center;
}

.btn-save span {
  font-size: 14px;
  vertical-align: -webkit-baseline-middle;
  color: theme.$text-white;
}

.property {
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid theme.$light-grey-background;
}

.property p {
  margin-top: 8px;
  margin-bottom: 16px;
}

.logout {
  margin-top: 16px;
}
</style>